/*
|--------------------------------------------------------------------------
| Views: Magazine
|--------------------------------------------------------------------------
*/
/**
 * Magazine
 * @namespace
 */
__gh__webApp.views.magazineFeatured = {

	"getSubView": function(bucket){
		var commonJS			= __gh__webApp.common,
			items 				= (bucket.items.main) ? bucket.items.main : {},
			commonViewJS		= __gh__webApp.views.common,
			viewFolder		 	= "buckets/magazineFeatured",
			viewName, hasImages;

		itemCount 		= 12;
		viewName 		= viewFolder+'/default';

		hasImages = __gh__webApp.data.itemValidator({
			"data": 			items.slice(0, itemCount),
			"required": 		itemCount,
			"validationMethod": "hasImage"
		});
		if(hasImages === false) {
			for(var i = 0; i < items.length; i++) {
				if(typeof items[i].image.link !== 'string') {
					items.splice(i, 1);
					i--;
				}
			}
		}

		getItems		= commonViewJS.splitItems(items,itemCount,bucket);
		
		bucket.view.name 	= viewName,	
		bucket.items 		= {
			"main"				: getItems.main.slice(0,2),
			"secondary"			: getItems.main.slice(2,4),
			"cols": {
				"col1"			: getItems.main.slice(4,8),
				"col2"			: getItems.main.slice(8,12)
			}
		};
		return bucket;

	}
};